import React, { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
// import useAppState from '@qirapagos/lib/hooks/useAppState'
import useInitApp from '@qirapagos/lib/hooks/useInitApp'
import Router from 'routes'
import { ENVIROMENT, Enviroments } from 'constants/enviroment'
import { GlobalDebug } from 'utils/common/consoles'
import { PauseModal } from 'components'
import { useAppSelector } from 'hooks/redux'
import { getFirebaseToken } from 'config/firebase'
import { useDispatch } from 'react-redux'
import { getNotifications } from 'store/notifications/thunks'
import { fetchSettings } from 'store/settings/thunks'

const App: React.FC = () => {
  const { checkDevice, setBusinessInfo } = useInitApp()
  const dispatch = useDispatch()
  const appStatus = useAppSelector(state => state.auth.appStatus)
  const settingsData = useAppSelector(state => state.settings.data)

  if (ENVIROMENT === Enviroments.PRODUCTION) {
    Sentry.init({
      dsn: process.env.REACT_APP_DSN_AGRO,
      environment: ENVIROMENT,
      integrations: [new BrowserTracing()],
      tracesSampleRate: 0.2
    })
  }

  useEffect(() => {
    getFirebaseToken()
  }, [])

  useEffect(() => {
    checkDevice()
    setBusinessInfo()
  }, [checkDevice, setBusinessInfo])

  useEffect(() => {
    checkDevice()
    setBusinessInfo()
  }, [checkDevice, setBusinessInfo])

  useEffect(() => {
    if (
      process.env.NODE_ENV === 'production' ||
      process.env.REACT_APP_ENV === 'production'
    ) {
      GlobalDebug(true, true)
    }
  }, [])

  useEffect(() => {
    let interval: any
    const startPolling = () => {
      dispatch(getNotifications())
      interval = setInterval(() => {
        dispatch(getNotifications())
      }, 30000)
    }

    const stopPolling = () => {
      if (interval) clearInterval(interval)
    }

    if (document.visibilityState === 'visible') {
      startPolling()
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        startPolling()
      } else {
        stopPolling()
      }
    }
    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      stopPolling()
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [dispatch])

  useEffect(() => {
    const isLogged = sessionStorage.getItem('isLogged') === 'true'
    if (isLogged && (!settingsData || Object.keys(settingsData).length === 0)) {
      dispatch(fetchSettings())
    }
  }, [dispatch, settingsData])

  // useAppState()

  return (
    <>
      <PauseModal isOpen={!appStatus} />
      <Router />
    </>
  )
}

export default App
